import { AImageProps } from '../../atoms/AImage/AImage.types';
import { MPhotoCaptionProps } from '../../molecules/MPhotoCaption/MPhotoCaption.types';
import { AScrimGradientProps } from '../../atoms/AScrimGradient/AScrimGradient.types';
import { MLogoContainerProps } from '../../molecules/MLogoContainer/MLogoContainer.types';
import { MTextBlockSimpleProps } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import { MButtonProps } from '../../molecules/MButton/MButton.types';

export enum OCardLayeredFeatureImageScale {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export interface OCardLayeredFeatureTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OCardLayeredFeatureProps extends React.HTMLAttributes<HTMLElement> {
  imageScale?: OCardLayeredFeatureImageScale;
  ctaLink?: string;
  aImage?: AImageProps;
  mPhotoCaption?: MPhotoCaptionProps;
  aScrimGradient?: AScrimGradientProps;
  mLogoContainer?: MLogoContainerProps;
  mTextBlockSimple?: MTextBlockSimpleProps;
  mButton?: MButtonProps;
  trackingProperties?: OCardLayeredFeatureTrackingProperties;
  className?: string;
}
